var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_20667)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.126 38.4269C6.16418 43.5608 0.342649 52.3691 0.0173284 61.8471C-0.307993 71.3251 5.53066 81.0434 14.4856 84.0654C19.177 85.645 24.2623 85.4218 29.2106 85.1643C35.8883 84.8209 42.583 84.4775 49.2607 84.1169C51.4523 83.9967 53.7124 83.8765 55.6472 82.8291C60.099 80.4253 60.9209 74.4672 61.1606 69.402C61.5544 61.332 61.8112 52.9701 58.7977 45.4839C56.4691 39.7147 51.692 34.4606 45.6136 32.7092C42.6686 31.8507 39.4839 32.1255 36.4533 32.1598C32.772 32.2113 29.0908 32.6577 25.5293 33.5506C21.5056 34.5636 17.6189 36.1776 14.126 38.4269Z",
    fill: "#18499A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6202 88.3407C38.8497 88.3407 38.0792 88.1862 37.3259 87.8771C34.9801 86.8984 33.559 84.632 33.6788 82.0908L34.2952 69.8827L22.1214 70.5009C19.5873 70.6382 17.3272 69.1959 16.3512 66.8436C15.3753 64.4913 15.9745 61.8814 17.858 60.1644L26.8985 51.9742L17.858 43.784C15.9917 42.1013 15.4095 39.4915 16.3683 37.1391C17.3443 34.7868 19.6044 33.3617 22.1385 33.4819L34.3124 34.1L33.696 21.892C33.559 19.3508 34.9973 17.0843 37.343 16.1056C39.6887 15.1269 42.2913 15.7279 44.0035 17.6166L52.1708 26.6825L60.3381 17.6166C62.0331 15.7279 64.6528 15.1441 66.9986 16.1056C69.3443 17.0843 70.7654 19.3508 70.6456 21.892L70.0292 34.1L82.203 33.4819C84.7371 33.3445 86.9973 34.7868 87.9732 37.1391C88.9492 39.4915 88.3499 42.1013 86.4665 43.8184L77.426 52.0086L86.4665 60.1987C88.3499 61.8986 88.9321 64.5256 87.9732 66.878C86.9973 69.2303 84.7371 70.6554 82.203 70.5352L70.0292 69.9171L70.6456 82.1251C70.7826 84.6663 69.3443 86.9328 66.9986 87.9115C64.6528 88.8902 62.0503 88.2892 60.3381 86.4005L52.1708 77.3346L44.0035 86.4005C42.8221 87.6539 41.2468 88.3407 39.6202 88.3407ZM36.1102 68.0799L35.3911 82.1766C35.2712 84.3744 36.6581 85.7309 37.9765 86.2975C39.312 86.8469 41.2468 86.8641 42.7022 85.2329L52.1365 74.7591L61.5708 85.2329C63.0434 86.8641 64.9782 86.8469 66.2966 86.2975C67.615 85.748 69.0019 84.3744 68.882 82.1766L68.1629 68.0799L82.2202 68.801C84.3947 68.904 85.7645 67.5304 86.3295 66.2083C86.8774 64.8862 86.8945 62.9288 85.2679 61.4693L74.8234 52.0086L85.2679 42.5478C86.8945 41.0711 86.8774 39.1309 86.3295 37.8088C85.7816 36.4867 84.3947 35.0959 82.2202 35.2161L68.1629 35.9372L68.882 21.8405C69.0019 19.6427 67.615 18.2863 66.2966 17.7196C64.9782 17.1702 63.0262 17.153 61.5708 18.7842L52.1365 29.258L42.7022 18.7842C41.2297 17.153 39.2949 17.1702 37.9765 17.7196C36.6581 18.2691 35.2712 19.6427 35.3911 21.8405L36.1102 35.9372L22.0529 35.2161C19.8613 35.0959 18.5086 36.4867 17.9436 37.8088C17.3957 39.1309 17.3786 41.0883 19.0052 42.5478L29.4497 52.0086L19.0052 61.4693C17.3786 62.946 17.3957 64.8862 17.9436 66.2083C18.4915 67.5304 19.8613 68.9212 22.0529 68.801L36.1102 68.0799Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4802 88.3408H15.9062V66.7063H17.6185V86.6238H37.4802V88.3408Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3845 37.2937H86.6723V17.3763H66.8105V15.6592H88.3845V37.2937Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3845 88.3408H66.8105V86.6238H86.6723V66.7063H88.3845V88.3408Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6185 37.2937H15.9062V15.6592H37.4802V17.3763H17.6185V37.2937Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1631 67.3072L0.890137 51.9914L16.1631 36.6927L17.3617 37.9118L3.30436 51.9914L17.3617 66.0882L16.1631 67.3072Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1367 103.399L36.8809 88.0832L38.0965 86.8813L52.1367 100.978L66.194 86.8813L67.4097 88.0832L52.1367 103.399Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1278 67.3072L86.9292 66.0882L100.969 51.9914L86.9292 37.9118L88.1278 36.6927L103.384 51.9914L88.1278 67.3072Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.194 17.1187L52.1367 3.02195L38.0965 17.1187L36.8809 15.9168L52.1367 0.600952L67.4097 15.9168L66.194 17.1187Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_20667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.41fc878c1e47c4688a362eb8a0fd3ec2.svg";
export { ForwardRef as ReactComponent };